export default class Activity {
  constructor(id = null, name = '', description = null, video = null, image = null, audio = null, external_link = null, external_link_description = null, activity_type = null) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.video = video;
    this.image = image;
    this.audio = audio;
    this.external_link = external_link;
    this.external_link_description = external_link_description;
    this.activity_type = activity_type;
  }
}
